// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__pSVpu","desabilitar":"OptionSelect_desabilitar__qXG5L","focado":"OptionSelect_focado__GlI9k","novo":"OptionSelect_novo__yS+u0"};